import ModalAppropriations from './ModalAppropriations'

export default ModalAppropriations
